import { useEffect, useRef } from 'react';
import NotificationService, { Notification } from '../../services/NotificationService';

export const useQueryResultRefresh = (queryId: string | number | null, refresh: () => void, pollIntervalMs: number | null) => {
    const refreshRef = useRef(refresh);
    refreshRef.current = refresh;

    useEffect(() => {
        if (queryId === null) return;
        const handleNotification = (notification: Notification) => {
            if (notification.queryId && String(notification.queryId) === String(queryId)) refreshRef.current();
        };
        NotificationService.on('new-notification', handleNotification);
        return () => {
            NotificationService.removeListener('new-notification', handleNotification);
        };
    }, [queryId]);

    useEffect(() => {
        if (queryId === null || pollIntervalMs === null) return;
        const interval = setInterval(() => refreshRef.current(), pollIntervalMs);
        return () => clearInterval(interval);
    }, [queryId, pollIntervalMs]);
};
